<template>
<div class="specialSettingMgt">
    <div class="filters">
        <div class="add flexstart">
            <el-button type="primary" @click="handleAdd">新建组别</el-button>
        </div>
        <div class="search"></div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%" ref="multipleTable">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="contentname" label="配置内容" min-width="300px" class-name="title">
                <template slot-scope="scope">
                    <div>{{scope.row.contentname}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="datetime" label="排序" class-name="tc" label-class-name="tc" width="100px">
                <template slot-scope="scope">
                    <div class="upordown">
                        <div class="icon_bb_arrow" :class="[scope.$index==0?'prohibit':'']">
                            <i @click.stop="handleUp(scope.row, scope.$index)" class="icon icon_bb_arrow_up"></i>
                        </div>
                        <div class="icon_bb_arrow" :class="[scope.$index==(tableData.length-1)?'prohibit':'']">
                            <i @click.stop="handleDown(scope.row, scope.$index)" class="icon icon_bb_arrow_down"></i>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                    <span class="separator-btn">
                        <el-button @click.stop="handleSetting(scope.row)" type="text" size="small">项目设置</el-button>
                    </span>
                        <span class="separator-btn">
                        <el-button @click.stop="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                    </span>
                        <span class="separator-btn">
                        <el-button @click.stop="handleDel(scope.row)" type="text" size="small">删除</el-button>
                    </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                       :page-size="page.pageSize"
                       :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
    <specialGroupDialog ref="specialGroupDialog" @openSpecialListDialog="_openSpecialListDialog" @refresh="_refresh"></specialGroupDialog>
    <specialListDialog ref="specialListDialog" @setContentinnerid="_setContentinnerid"></specialListDialog>
    <specialProjectSettingDialog ref="specialProjectSettingDialog" @openGroupDialog="handleTaskAdd"></specialProjectSettingDialog>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getAllQuestionbankindexsection, deleteQuestionbanktopicsection, uploadQuestionbanktopicsectionindex} from 'api/questionApi'
import SpecialGroupDialog from 'views/cms/special/components/specialGroupDialog.vue'
import SpecialListDialog from 'views/cms/special/components/specialListDialog.vue'
import SpecialProjectSettingDialog from 'views/cms/special/components/specialProjectSettingDialog.vue'

export default {
    name: 'specialSettingMgt',
    data() {
        return {
            tableData: [],
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            total: 0,
            param: {
                examcode: this.$route.query.examcode ? this.$route.query.examcode : ''
            },
            init: false
        }
    },
    mounted() {
    },
    methods: {
        _refresh(type) {
            if (type == 1) {
               this._getList()
            } else {
                this.$refs.specialProjectSettingDialog.getList()
            }
        },
        _openSpecialListDialog(selectResult) {
            this.$refs.specialListDialog.openDialog(this.param.examcode, selectResult)
        },
        _setContentinnerid(selectResult) {
            this.$refs.specialGroupDialog.setContentinnerid(selectResult)
        },
        handleAdd() {
            this.$refs.specialGroupDialog.openDialog(1, {})
        },
        handleTaskAdd(selectRow) {
            this.$refs.specialGroupDialog.openDialog(2, selectRow)
        },
        handleSetting(row) {
            this.$refs.specialProjectSettingDialog.openDialog(row.innerid)
        },
        handleEdit(row) {
            this.$refs.specialGroupDialog.openDialog(1, {innerid: row.innerid})
        },
        handleDel(row) {
            this.$confirm('删除组别后其附属的子信息将会一起删除，继续吗？', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._del(row.innerid)
            })
        },
        initData() {
            if (!this.init) this._getList()
        },
        handleUp(obj, index) {
            let item = {
                catetype: -1, // 上移-1 下移1
                examcode: this.param.examcode,
                innerid: obj.innerid, // 组别id ,
                taskinnerid: '', // 项目id
                type: 1 // 类型 1 组别 2项目
            }
            this._editIndex(item, index)
        },
        handleDown(obj, index) {
            let item = {
                catetype: 1, // 上移-1 下移1
                examcode: this.param.examcode,
                innerid: obj.innerid, // 组别id ,
                taskinnerid: '', // 项目id
                type: 1 // 类型 1 组别 2项目
            }
            this._editIndex(item, index)
        },
        _editIndex(param, index) {
            this.setLoading(true)
            uploadQuestionbanktopicsectionindex({
                data: param,
                success: () => {
                    this.$message.success(`${param.catetype==1? '下移': '上移'}成功`)
                    let obj = this.tableData[index]
                    this.tableData.splice(index, 1)
                    if (param.catetype==1) {
                        this.tableData.splice(index + 1, 0, obj)
                    } else {
                        this.tableData.splice(index - 1, 0, obj)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _del(param) {
            this.setLoading(true)
            deleteQuestionbanktopicsection({
                data: {innerid: param},
                success: () => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getAllQuestionbankindexsection({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.init = true
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        SpecialGroupDialog, SpecialListDialog, SpecialProjectSettingDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.specialSettingMgt {
    .upordown {
        display: flex;
        justify-content: center;
        align-items: center;
        .icon_bb_arrow {
            width: 20px;
            height: 20px;
            cursor: pointer;
            .icon {
                width: 100%;
                height: 100%;
            }
        }
        .icon_bb_arrow.prohibit{
            cursor: default;
        }
        .icon_bb_arrow+ .icon_bb_arrow{
            margin-left: 20px;
        }
    }
    .filters{
        margin-bottom: 10px;
    }
    .dialog-footer{
        margin-top: 0 !important;
    }
}
</style>
